// 简化版 PureHttp，适用于门户网（无登录、少量接口）
import axios, {
    type AxiosInstance,
    type AxiosRequestConfig,
    type AxiosResponse
  } from "axios";
  import { ElMessage } from "element-plus";
  import { stringify } from "qs";
  import { Code } from "@/config/error-code";
import { getActivePinia } from "pinia";
import { useSystemConfigStoreHook } from "@/store/modules/systemConfig";
import { Lang } from "@/config";
import { DeviceUtils } from "../device";
import { PlatformEnum } from "@/config/constantsEnum";
  type CustomParamsSerializer = (params: any) => string;
  // 获取环境变量工具
  const getEnv = () => {
    return {
      baseApi: import.meta.env.VITE_API_HOST || "/v1",
      childDomain: import.meta.env.VITE_CHILD_DOMAIN || "",
      isDev: import.meta.env.MODE === "development",
      isProd: import.meta.env.MODE === "production",
      isStaging: import.meta.env.MODE === "staging"
    };
  };
  
  const env = getEnv();
  
  // 默认配置
  const defaultConfig: AxiosRequestConfig = {
    baseURL: "/v1", // Vite dev proxy will map this to actual target
    timeout: 10000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    paramsSerializer: {
      serialize: stringify as unknown as CustomParamsSerializer
    }
  };
  
  class PortalHttp {
    private instance: AxiosInstance;
  
    constructor() {
      this.instance = axios.create(defaultConfig);
      this.setupInterceptors();
    }
  
    private setupInterceptors() {
      // 请求拦截
      this.instance.interceptors.request.use(
        (config) => {
          const pinia = getActivePinia();
          if (pinia) {
            const sysStore = useSystemConfigStoreHook();
            config.headers.Lang = sysStore.currentLang || Lang.LAN_CN;
          } else {
            console.warn("Pinia not initialized, using default lang");
            config.headers.Lang = Lang.LAN_CN;
          }
          if (env.childDomain) {
            config.headers["childDoMain"] = env.childDomain;
          }
          
          // 设置当前设备信息
          config.headers['platform'] = DeviceUtils.isMobile()
            ? PlatformEnum.MOBILE
            : PlatformEnum.PC

          return config;
        },
        (error) => Promise.reject(error)
      );
  
      // 响应拦截
      this.instance.interceptors.response.use(
        (response: AxiosResponse) => {
          const { data } = response;
          if (data.statusCode ===Code.SUCCESS.statusCode) { 
            return data;
          } else {
            ElMessage.error(data.message || "请求失败");
            return Promise.reject(new Error(data.message || "请求失败"));
          }
        },
        (error) => {
          ElMessage.error("网络错误或服务器异常");
          return Promise.reject(error);
        }
      );
    }
  
    public get<T = any>(url: string, params?: any, config?: AxiosRequestConfig): Promise<T> {
      return this.instance.get(url, { params, ...config });
    }
  
    public post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
      return this.instance.post(url, data, config);
    }
  }
  let portalHttpInstance: PortalHttp | null = null;
  export const getPortalHttp = () => {
    if (!portalHttpInstance) {
      portalHttpInstance = new PortalHttp();
    }
    return portalHttpInstance;
  };